import { TICKER_ITEMS } from '../constants/data'
/**
 * TickerMarquee — infinite horizontal scroll of tech skills.
 * Content is duplicated for a seamless CSS-only loop.
 * Pauses on hover.
 */
export function TickerMarquee() {
  const row = TICKER_ITEMS.map((t, i) => (
    <span className="tick-item" key={i}>
      <span className="tick-dot"/><b>{t}</b>
    </span>
  ))
  return (
    <div className="tick-wrap">
      <div className="tick-track">{row}{row}</div>
    </div>
  )
}
